import React from 'react';
import classnames from 'classnames';

import Dropdown from 'ub/components/dropdown/dropdown';
import ModalTabs from 'ub/components/modal/components/ModalTabs';
import SourceTab from './source-tab';
import SOURCES from 'ub/ui/asset-library/asset-sources';
import { assetSourcePropType, assetTypePropType, sortByPropType } from './prop-types';
import { TYPES } from 'ub/ui/asset-library/asset-types';

import styles from './toolbar.scss';
import arrowIcon from 'ub/icons/arrow-down.svg';

const SORT_OPTIONS = [
  { value: 'date', label: 'Date Uploaded' },
  { value: 'filename', label: 'Name' },
  { value: 'filesize', label: 'Size' },
];

export default class Toolbar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleChangeSearch = this.handleChangeSearch.bind(this);
    this.handleChangeSort = this.handleChangeSort.bind(this);
    this.handleStartDelete = this.handleStartDelete.bind(this);
    this.handleFocusSearch = this.handleFocusSearch.bind(this);
  }

  handleChangeType(selectedType) {
    this.props.dispatch({ type: 'changeType', assetType: selectedType });
  }

  handleChangeSearch(event) {
    this.props.dispatch({ type: 'changeSearch', value: event.target.value });
  }

  handleChangeSource(source) {
    this.props.dispatch({ type: 'changeSource', source });
  }

  handleChangeSort(sortBy) {
    this.props.dispatch({ type: 'changeSort', sortBy });
  }

  handleToggleSortDirection() {
    this.props.dispatch({ type: 'toggleSortDirection' });
  }

  handleStartDelete() {
    this.props.dispatch({ type: 'startDelete' });
  }

  handleFocusSearch(event) {
    window.editor.keyController.requestFocus(event.target);
  }

  render() {
    const {
      deleteAllowed,
      deleteEnabled,
      onlyImages,
      searchTerm,
      selectedSource,
      selectedType,
      sortAllowed,
      sortAscending,
      sortBy,
      sourceDescription,
      sourceTotals,
      typeTotals,
      visibleTypes,
    } = this.props;

    const tabs = onlyImages ? (
      // When the asset library is in `onlyImages` mode, the tabs should display the asset sources
      // ("My Images", "Public Images", "Unsplash")
      <ModalTabs
        selectedValue={selectedSource}
        tabs={Object.keys(SOURCES)
          .filter(source => SOURCES[source].enabled)
          .map(source => ({
            label: <SourceTab source={source} totalItems={sourceTotals[source]} />,
            value: source,
          }))}
        onChange={value => this.handleChangeSource(value)}
      />
    ) : (
      // Otherwise the tabs should display the types ("Images", "Documents", "Media", "Other")
      <ModalTabs
        selectedValue={selectedType}
        tabs={visibleTypes.map(type => ({
          label:
            TYPES[type].tabText +
            (typeof typeTotals[type] === 'number' ? ` (${typeTotals[type]})` : ''),
          value: type,
        }))}
        onChange={value => this.handleChangeType(value)}
      />
    );

    return (
      <div className={styles.wrapper}>
        {tabs}

        <div className={styles.controls}>
          {sourceDescription && <div className={styles.sourceDescription}>{sourceDescription}</div>}

          {sortAllowed && (
            <div className={styles.sort}>
              <label>Sort:</label>

              <Dropdown
                changeHandler={this.handleChangeSort}
                className={styles.sortDropdown}
                isLight
                options={SORT_OPTIONS}
                value={sortBy}
              />

              <div
                className={classnames(styles.sortDirection, {
                  [styles.isAscending]: sortAscending,
                })}
                dangerouslySetInnerHTML={{ __html: arrowIcon }} // eslint-disable-line react/no-danger
                onClick={() => this.handleToggleSortDirection()}
              />
            </div>
          )}

          <div className={styles.searchWrapper}>
            <input
              type="text"
              className={styles.searchInput}
              placeholder={`Search "${SOURCES[selectedSource].label}"`}
              value={searchTerm}
              onChange={this.handleChangeSearch}
              onFocus={this.handleFocusSearch}
            />
            <div className={classnames(styles.searchIcon, 'svg-ico-search')} />
          </div>

          {deleteAllowed && (
            <button
              className={classnames(styles.deleteButton, 'svg-ico-delete')}
              disabled={!deleteEnabled}
              type="button"
              onClick={this.handleStartDelete}
            >
              Delete Selected
            </button>
          )}
        </div>
      </div>
    );
  }
}

Toolbar.propTypes = {
  deleteAllowed: React.PropTypes.bool.isRequired,
  deleteEnabled: React.PropTypes.bool.isRequired,
  dispatch: React.PropTypes.func.isRequired,
  onlyImages: React.PropTypes.bool.isRequired,
  searchTerm: React.PropTypes.string.isRequired,
  selectedSource: assetSourcePropType.isRequired,
  selectedType: assetTypePropType.isRequired,
  sortAllowed: React.PropTypes.bool.isRequired,
  sortAscending: React.PropTypes.bool.isRequired,
  sortBy: sortByPropType.isRequired,
  sourceDescription: React.PropTypes.string,
  sourceTotals: React.PropTypes.object.isRequired,
  typeTotals: React.PropTypes.object.isRequired,
  visibleTypes: React.PropTypes.arrayOf(assetTypePropType).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/toolbar.jsx